
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecarrentalsserviceinpune() {



    const cardData =
    {
        keyword: 'Corporate Car Rentals Services in Pune ',
        heading: 'etravo : Corporate Car Rentals Services in Pune',
"headingDescription": "eTravo provides professional Corporate Car Rental Services in Pune, tailored to meet the evolving needs of businesses, IT companies, and executives. With a fleet of well-maintained, GPS-enabled vehicles and experienced chauffeurs, eTravo ensures punctual, safe, and comfortable travel for employee transportation, airport transfers, client meetings, and corporate events. Flexible hourly, daily, and monthly plans make it a reliable mobility partner across Pune’s major business hubs.","top": "Top Corporate Car Rental Services in Pune with eTravo","topPlaces": [  {    "title": "Hinjewadi IT Park",    "description": "eTravo offers tailored corporate mobility solutions including chauffeur-driven cars, employee transportation, and executive travel services. Known for punctuality and flexibility, it serves key IT hubs like Kharadi, Hinjewadi, and Magarpatta."  },  {    "title": "Kharadi IT Park",    "description": "A dedicated corporate car rental provider offering 24/7 services for business travel, airport transfers, and employee commute. It is strategically located near Kharadi, one of Pune’s major IT hubs."  },  {    "title": "Magarpatta City",    "description": "Provides comprehensive corporate transport solutions including employee pickup and drop, minibus services, and business travel support with round-the-clock availability."  },  {    "title": "Baner-Balewadi Business District",    "description": "Offers professional chauffeur-driven services for corporate clients, including airport transfers, intercity travel, and customized business travel plans across Pune and nearby cities."  },  {    "title": "Viman Nagar",    "description": "A reliable option for corporate travel needs, offering a wide fleet including sedans, SUVs, and tempo travellers suitable for team transport and executive travel."  },  {    "title": "Koregaon Park",    "description": "Located near Pune Airport, this service specializes in luxury and executive car rentals, making it ideal for VIP corporate travel and airport transfers."  },  {    "title": "Hadapsar",    "description": "Offers flexible car rental solutions for corporate professionals who prefer self-drive options, with easy access from business hubs like Magarpatta and Hadapsar."  },  {    "title": "Wakad",    "description": "Provides self-drive and long-term leasing options for corporate clients, enabling flexible and cost-effective transportation for employees and executives."  },  {    "title": "Shivajinagar",    "description": "A popular rental provider offering a variety of vehicles suitable for corporate use, including daily rentals and long-term leasing for business requirements."  },  {    "title": "Pimpri-Chinchwad",    "description": "Offers dependable car rental services with a wide fleet and strong presence near Koregaon Park, catering to corporate travel, airport transfers, and team outings."  }],


"services": [
{
"name": "Corporate Car Rental Services Pune",
"description": "eTravo provides reliable corporate car rental services in Pune designed for smooth and professional business transportation. From daily office commutes to executive travel, our services ensure punctuality, comfort, and efficiency across all major corporate hubs like Hinjewadi, Baner, and Magarpatta. With well-maintained vehicles and experienced chauffeurs, we help businesses maintain a strong professional image."
},
{
"name": "Corporate Cab Services Pune",
"description": "Our corporate cab services in Pune are tailored for companies seeking dependable and flexible transport solutions. Whether it’s employee travel, client visits, or meetings, eTravo ensures timely pickups, clean vehicles, and a seamless travel experience that supports daily business operations."
},
{
"name": "Company Car Rental Pune",
"description": "eTravo offers company car rental in Pune with customized solutions for businesses of all sizes. Our fleet includes sedans and SUVs suitable for employee transport and executive travel, ensuring comfort, safety, and consistent service quality for every journey."
},
{
"name": "Corporate Transport Provider Pune",
"description": "As a trusted corporate transport provider in Pune, eTravo delivers structured and efficient mobility solutions for organizations. We manage employee travel, executive movements, and client transport with a focus on punctuality, reliability, and professional service standards."
},
{
"name": "Office Cab Service Pune",
"description": "Simplify daily office travel with eTravo’s office cab service in Pune. We provide reliable pickup and drop services for employees, ensuring timely arrivals and smooth coordination between home and workplace locations across the city."
},
{
"name": "Corporate Fleet Rental Pune",
"description": "eTravo offers corporate fleet rental in Pune for businesses that require multiple vehicles regularly. Our fleet solutions ensure consistent availability, proper maintenance, and efficient operations, helping companies manage transportation needs without hassle."
},
{
"name": "Business Cab Services Pune",
"description": "Choose eTravo’s business cab services in Pune for comfortable and efficient corporate travel. Ideal for meetings, site visits, and client handling, our services ensure a professional and stress-free travel experience for executives and teams."
},
{
"name": "Professional Transport Pune",
"description": "Our professional transport services in Pune are designed to meet high corporate standards. With trained drivers, clean vehicles, and punctual service, eTravo ensures every journey reflects professionalism and reliability."
},
{
"name": "Corporate Car Booking Pune",
"description": "eTravo provides easy and flexible corporate car booking in Pune for on-demand business travel. Whether you need a car for a few hours or an entire day, our booking process is simple, and our service ensures comfort and punctuality."
},
{
"name": "Company Travel Services Pune",
"description": "Manage your business travel efficiently with eTravo’s company travel services in Pune. We offer end-to-end transport solutions for employees, executives, and clients, ensuring smooth coordination and hassle-free travel experiences."
},
{
"name": "Corporate Vehicle Hire Pune",
"description": "eTravo offers corporate vehicle hire in Pune with a wide range of options including sedans and SUVs. Our services are ideal for meetings, corporate events, and employee transport, delivering comfort and reliability every time."
},
{
"name": "Corporate Mobility Solutions Pune",
"description": "eTravo’s corporate mobility solutions in Pune are designed to optimize business travel. From route planning to daily transport management, we help companies improve efficiency, reduce costs, and ensure seamless movement for employees and executives."
},
{
"name": "Staff Transport Pune",
"description": "eTravo provides dependable staff transport services in Pune with well-planned pickup and drop solutions. Our services ensure safety, punctuality, and convenience for employees, helping organizations maintain smooth daily operations."
},
{
"name": "Employee Cab Services Pune",
"description": "Our employee cab services in Pune are designed for safe and comfortable workforce transportation. With trained drivers and well-maintained vehicles, eTravo ensures timely travel and a hassle-free commute for employees across the city."
},
{
"name": "Corporate Taxi Services Pune",
"description": "eTravo offers corporate taxi services in Pune for businesses requiring quick and reliable transport. Whether it’s local travel or outstation trips, our taxis provide comfort, punctuality, and a professional experience for every ride."
}
],
"tableData": [
["Corporate Car Rental Services Pune", "Corporate Cab Services Pune"],
["Company Car Rental Pune", "Corporate Transport Provider Pune"],
["Office Cab Service Pune", "Corporate Fleet Rental Pune"],
["Business Cab Services Pune", "Professional Transport Pune"],
["Corporate Car Booking Pune", "Company Travel Services Pune"],
["Corporate Vehicle Hire Pune", "Corporate Mobility Solutions Pune"],
["Staff Transport Pune", "Employee Cab Services Pune"],
["Corporate Taxi Services Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Professional Corporate Car Rental Services in Pune",
      "WhyChoosedescription": "eTravo offers premium corporate car rental services in Pune designed to meet the dynamic travel needs of businesses, ensuring seamless mobility across key commercial hubs like Hinjewadi, Baner, and Kharadi."
    },
    {
      "WhyChooseheading": "Comprehensive Fleet for All Corporate Needs",
      "WhyChoosedescription": "Our wide range of vehicles includes hatchbacks, sedans, SUVs, and luxury cars, perfectly suited for employee transport, executive travel, and high-profile business requirements."
    },
    {
      "WhyChooseheading": "Guaranteed On-Time Service",
      "WhyChoosedescription": "We understand the importance of punctuality in business operations. eTravo ensures timely pickups and drop-offs, helping companies maintain efficiency and professionalism."
    },
    {
      "WhyChooseheading": "Highly Trained Corporate Chauffeurs",
      "WhyChoosedescription": "Our chauffeurs are professionally trained with strong knowledge of routes and corporate etiquette, ensuring safe, smooth, and respectful travel for employees and clients."
    },
    {
      "WhyChooseheading": "Customizable Corporate Travel Plans",
      "WhyChoosedescription": "eTravo provides flexible rental options including hourly, daily, and long-term contracts, allowing businesses to customize travel solutions according to their specific needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing and Billing System",
      "WhyChoosedescription": "We offer clear pricing structures with GST-compliant invoices and no hidden charges, helping businesses manage travel expenses efficiently and transparently."
    },
    {
      "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced, cleaned, and sanitized, ensuring maximum safety, comfort, and reliability for every corporate journey."
    },
    {
      "WhyChooseheading": "24/7 Dedicated Support for Businesses",
      "WhyChoosedescription": "Our round-the-clock customer support ensures quick assistance for bookings, modifications, and emergency travel needs, providing uninterrupted corporate mobility."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What services are included in corporate car rental services in Pune?',
            answer: 'eTravo provides chauffeur-driven cars, airport transfers, employee transport, executive travel, and customized corporate mobility solutions in Pune.',
        },
        {
            question: 'Can I book corporate car rental services in Pune for long-term use?',
            answer: 'Yes, eTravo offers flexible long-term rental options including monthly and yearly contracts for businesses.',
        },
        {
            question: 'Which vehicles are available for corporate rentals in Pune?',
            answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars suitable for all types of corporate travel needs.',
        },
        {
            question: 'Are the drivers trained for corporate travel services?',
            answer: 'Yes, our chauffeurs are professionally trained and experienced in handling corporate clients with proper etiquette and safety standards.',
        },
        {
            question: 'Do you provide airport transfer services for corporate clients in Pune?',
            answer: 'Yes, we offer reliable airport pickup and drop services for corporate employees and executives.',
        },
        {
            question: 'Is corporate car rental service available 24/7 in Pune?',
            answer: 'Yes, eTravo operates round the clock to support business travel requirements at any time.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, we provide fully customizable travel solutions based on company requirements, schedules, and budgets.',
        },
        {
            question: 'Do you provide GST billing for corporate car rentals?',
            answer: 'Yes, we provide proper GST invoices for all corporate bookings to ensure easy accounting and compliance.',
        },
        {
            question: 'Are the vehicles regularly maintained and sanitized?',
            answer: 'Yes, all vehicles undergo regular servicing and cleaning to ensure safety and hygiene.',
        },
        {
            question: 'How can I book corporate car rental services in Pune?',
            answer: 'You can book through our website or contact our support team for quick and hassle-free corporate bookings.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Joshi',
        designation: 'Admin Head, Vertex Technologies, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate car rental services in Pune have improved our daily operations. Their punctual service and professional drivers make business travel smooth and efficient.”',
    },
    {
        name: 'Ms. Sneha Kulkarni',
        designation: 'HR Manager, BrightEdge Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We trust eTravo for all our corporate travel needs in Pune. Their flexible plans and well-maintained vehicles ensure a comfortable and reliable experience for our employees.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rentals Services in Pune",
  "image": "https://www.etravo.in/images/keyword/corporate-car-rental-services-pune.jpg",
  "description": "Reliable corporate car rental services in Pune by eTravo. Perfect for company travel, staff transport, employee cab services, corporate taxi bookings, and professional business mobility solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-car-rentals-services-in-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Corporate Car Rentals Services in Pune | Company Cab & Transport Solutions | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate car rental services in Pune with eTravo for staff transport, company travel, corporate taxi services, and professional mobility solutions. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/corporate-car-rental-services-in-pune.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecarrentalsserviceinpune;